



















































































































































import Vue, { PropType } from "vue";
import { ValidationProvider } from "vee-validate";
// enum
import { AuthorityEnum } from "@/features/setting/enums/Authority";
// types
import { Publisher } from "@/features/setting/types";
import { Enum } from "@/commons/enums/Type";

export default Vue.extend({
  components: {
    "validation-provider": ValidationProvider,
  },

  props: {
    nameInput: { type: String, required: true },
    emailInput: { type: String, required: true },
    passwordInput: { type: String, required: true },
    confirmedPasswordInput: { type: String, required: true },
    authority: { type: Array as PropType<Enum[]>, required: true },
    authorityInput: { type: Number, required: false, default: null },
    publishers: {
      type: Array as PropType<Publisher[]>,
      required: true,
    },
    publishersInput: {
      type: Array as PropType<Publisher[]>,
      required: true,
    },
    clickSave: { type: Function as PropType<() => void>, required: true },
    clickCancel: { type: Function as PropType<() => void>, required: true },
    loading: { type: Boolean, required: true },
  },

  data() {
    return {
      showPassword: false as boolean,
      showConfirmedPassword: false as boolean,
    };
  },

  computed: {
    localNameInput: {
      get(): string {
        return this.nameInput;
      },
      set(val: string) {
        return this.$emit("update:nameInput", val);
      },
    },
    localEmailInput: {
      get(): string {
        return this.emailInput;
      },
      set(val: string) {
        return this.$emit("update:emailInput", val);
      },
    },
    childPasswordInput: {
      get(): string {
        return this.passwordInput;
      },
      set(val: string) {
        return this.$emit("update:passwordInput", val);
      },
    },
    childConfirmedPasswordInput: {
      get(): string {
        return this.confirmedPasswordInput;
      },
      set(val: string) {
        return this.$emit("update:confirmedPasswordInput", val);
      },
    },
    localAuthorityInput: {
      get(): number {
        return this.authorityInput;
      },
      set(val: number) {
        return this.$emit("update:authorityInput", val);
      },
    },
    localPublishersInput: {
      get(): Publisher[] {
        return this.publishersInput;
      },
      set(val: Publisher[]) {
        return this.$emit("update:publishersInput", val);
      },
    },
  },

  methods: {
    isVisiblePublisher(userType: number): boolean {
      return !(
        AuthorityEnum.checkMasterByValue(userType) || AuthorityEnum.checkFluxByValue(userType)
      );
    },
  },
});
